import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    maxHeight: '100vh',
    background: theme.palette.common.white,
    padding: `0 ${theme.spacing(3)}px`,
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 10000,
    boxSizing: 'border-box',
    userSelect: 'none',

    [theme.breakpoints.up('sm')]: {
      width: '100vw',
      maxWidth: '100vw',
    },
  },
  logo: {
    marginTop: theme.spacing(6.5),
    width: 64,
    height: 64,
  },
  title: {
    fontWeight: 'bold',
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  subtitle: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  loading: {
    color: theme.palette.common.white,
  },
  errorCode: {
    position: 'absolute',
    right: theme.spacing(3),
    bottom: theme.spacing(3),
    color: theme.palette.primary.main,
  },
});
